import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translations
import en from '../locales/en_US.json';
import cs from '../locales/cs_CZ.json';
import de from '../locales/de_DE.json';
import fr from '../locales/fr_FR.json';
import es from '../locales/es_ES.json';

// Centralized language configuration
export const SUPPORTED_LANGUAGES = [
  {
    code: 'en_US',
    label: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    translation: en
  },
  {
    code: 'cs_CZ',
    label: 'Čeština',
    nativeName: 'Čeština',
    flag: '🇨🇿',
    translation: cs
  },
  {
    code: 'de_DE',
    label: 'Deutsch',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    translation: de
  },
  {
    code: 'fr_FR',
    label: 'Française',
    nativeName: 'Français',
    flag: '🇫🇷',
    translation: fr
  },
  {
    code: 'es_ES',
    label: 'Español',
    nativeName: 'Español',
    flag: '🇪🇸',
    translation: es
  }
];

// Generate resources object from language configuration
const resources = SUPPORTED_LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = { translation: lang.translation };
  return acc;
}, {});

// Helper functions
export const getLanguageByCode = (code) => {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code);
};

export const getLanguageOptions = () => {
  return SUPPORTED_LANGUAGES.map(({ code, label, flag }) => ({ code, label, flag }));
};

export const getSupportedLanguageCodes = () => {
  return SUPPORTED_LANGUAGES.map(lang => lang.code);
};

let Backend;

if (typeof window !== "undefined") {
  Backend = require("i18next-xhr-backend").default;
}

if (!i18n.isInitialized) {
i18n
  //.use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en_US',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    backend: Backend ? {
    // path where translation files are stored
    loadPath: '/locales/{{lng}}.json',
  } : undefined,
    // Important for SSR
    react: {
      useSuspense: false
    }
  });
}

export default i18n;